import { Alert, Button, Typography } from 'antd';
import React from 'react';
import { PlaygroundContext } from '../context/PlaygroundContext';

const { Paragraph, Text } = Typography;

export const ErrorBanner: React.FC = () => {
  const { errors, dismissError, clearErrors } =
    React.useContext(PlaygroundContext);

  if (!errors.length) return null;

  const latest = errors[0];

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        padding: '12px 16px',
        background: 'transparent'
      }}
    >
      <Alert
        type="error"
        showIcon
        message={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>{latest.title}</span>
            {errors.length > 1 && (
              <Text type="secondary" style={{ fontWeight: 400 }}>
                ({errors.length} issues)
              </Text>
            )}
          </div>
        }
        description={
          latest.description || latest.details ? (
            <div>
              {!!latest.description && (
                <Paragraph style={{ marginBottom: 8 }}>
                  {latest.description}
                </Paragraph>
              )}
              {!!latest.details && (
                <pre
                  style={{
                    margin: 0,
                    padding: 12,
                    background: '#fff1f0',
                    borderRadius: 6,
                    overflow: 'auto',
                    border: '1px solid #ffa39e'
                  }}
                >
                  {latest.details}
                </pre>
              )}
            </div>
          ) : undefined
        }
        action={
          <div style={{ display: 'flex', gap: 8 }}>
            {errors.length > 1 && (
              <Button size="small" onClick={() => clearErrors()}>
                Clear all
              </Button>
            )}
            <Button size="small" onClick={() => dismissError(latest.id)}>
              Close
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default ErrorBanner;
